import { create } from 'zustand';
import {
  DefaultDataType,
  NavAndEpsParameters,
  NavDataType,
  NavFilterType,
  NavSummaryType,
  NavWatchType,
  StockType,
} from 'typings/nav.type';
import {
  getDefaultDataAction,
  getNavDataAction,
  getWatchDataAction,
  putChangedFormulaAction,
} from './action';

type NavType = {
  navDataLoading: boolean;
  navDataError: boolean;
  navData: NavDataType;
  navParameters: NavAndEpsParameters;
  stock: StockType[];
  outOfExchange: StockType[];
  defaultData: DefaultDataType;
  summaryData: NavSummaryType;
  getNavDataAction: (securityId: string, navId: string) => Promise<void>;
  getDefaultDataAction: (
    securityId: string,
    navId: string,
    defaultStatus: boolean,
  ) => Promise<DefaultDataType>;
  putChangedFormulaAction: (
    stock: StockType[],
    outOfExchange: StockType[],
    navData: NavDataType,
  ) => Promise<void>;
  watchLoading: boolean;
  watchError: boolean;
  changeFormulaLoading: boolean;
  changeFormulaError: boolean;
  navWatchData: NavWatchType[];
  epsWatchData: NavWatchType[];
  getWatchDataAction: (isNav?: boolean) => Promise<void>;
  navFilters: NavFilterType;
  setNavFiltersAction: (body: NavFilterType) => void;
  reset: () => void;
};

const initialState = {
  navDataLoading: false,
  navDataError: false,
  navData: null,
  stock: null,
  defaultData: null,
  outOfExchange: null,
  watchLoading: false,
  watchError: false,
  navWatchData: null,
  epsWatchData: null,
  summaryData: null,
  navParameters: null,
  changeFormulaLoading: false,
  changeFormulaError: false,
  navFilters: null,
};

const useNavStore = create<NavType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  getNavDataAction: async (securityId, navId): Promise<void> =>
    getNavDataAction(set, securityId, navId),
  getDefaultDataAction: async (
    securityId,
    navId,
    defaultStatus,
  ): Promise<DefaultDataType> =>
    getDefaultDataAction(set, securityId, navId, defaultStatus),
  putChangedFormulaAction: async (
    stock,
    outOfExchange,
    navData,
  ): Promise<void> =>
    putChangedFormulaAction(set, stock, outOfExchange, navData),
  getWatchDataAction: async (isNav): Promise<void> =>
    getWatchDataAction(set, isNav),
  setNavFiltersAction: (navFilters): void => set({ navFilters }),
}));

export default useNavStore;
